import React from "react";
import ReactDOM from "react-dom";

import App from 'App';

// core components
import 'antd/dist/antd.css';
import "assets/css/material-dashboard-react.css?v=1.9.0";

// console.log(window.location.protocol, "TESTE")
// if (window.location.protocol === 'http:') {

// 	console.log("you are accessing us via "
// 		+ "an insecure protocol (HTTP). "
// 		+ "Redirecting you to HTTPS.");

// 	window.location.href =
// 		window.location.href.replace(
// 			'http:', 'https:');
// }

ReactDOM.render(

	//<React.StrictMode>
	<App />
	//</React.StrictMode>
	,
	document.getElementById("root")

);

